module.exports = __webpack_public_path__ + "static/media/Info.fcc1e9dd.svg";